<!-- eslint-disable no-tabs -->
<template>
  <div>
    <div v-if="isListLoadingCompleted" class="panel-notification is-scroll"
        infinite-scroll-disabled="loadCheck"
        infinite-scroll-throttle-delay="400"
        infinite-scroll-distance="10"
    >
      <div
        class="list-notification"
        v-for="(item, index) in data"
        :key="'indent-' + index"
      >

        <i class="icon-list">
          <svgicon v-if="item.order_type === 1"
            class="ct-icon"
            name="icon-status-open"
            :original="true"
          />
          <svgicon v-else
            class="ct-icon"
            name="icon-status-contract"
            :original="true"
          />
        </i>
        <div class="list-content">
          <div>
            <p>
              <strong>
                {{item.indent_number}}
              </strong>
            </p>
            <p>
              Transporter :
              <strong>
                {{item.transporter_name}}
              </strong>
            </p>
            <p>
              Status :
              <strong>
                {{item.indent_status}}
              </strong>
            </p>
          </div>
          <div class="ml-auto text-muted mr-10">
            <a :href="`/indents/${item.indent_number}/details/0`" target="_blank" class="external-link">
              Details
              <svgicon name="external" class="external-link-icon"
                width="10" height="10" :original="true" />
            </a>
          </div>
          <!-- <div class="ml-auto text-muted mr-10">
            {{item.created_at}}
          </div> -->
        </div>
      </div>
      </div>
      <div v-if="!data.length && isListLoadingCompleted"
      class="status-msg my-sm" size="small" text="top-left" style="width:45%;">
        <div class="status-content">
          <span class="status-inner">
            <img :src="NoData" width="200" height="180" class="img-responsive" alt=""/>
            <p style="width:100px; left:20px;">{{ $t('INDENT_NO_DATA_FOUND') }}</p>
          </span>
        </div>
      </div>
      <div v-if="!isListLoadingCompleted" class="status-msg my-md" style="width:45%;">
        <span>
          <img :src="LoaderCommon" width="240" class="img-responsive" alt=""/>
        </span>
      </div>
  </div>
  </template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import NoData from '@common/asset/images/status-no-data.png';
// eslint-disable-next-line import/no-extraneous-dependencies
import LoaderCommon from '@common/asset/images/loader-common.gif';


import { transactionTypes } from '@/constants/integrations';

export default {
  name: 'entity-list',
  props: {
    data: {
      type: Array,
    },
    isListLoadingCompleted: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedItem: null,
      NoData,
      LoaderCommon,
      transactionTypes,
    };
  },
  computed: {
    isSelectedLog() {
      return ((entityNo, apiName) => !!(this.selectedItem &&
      (this.selectedItem.entity_no || this.selectedItem.entity_id) === entityNo) &&
          !!(this.selectedItem && (this.selectedItem.api_name) === apiName));
    },
  },
  methods: {
    // loadMore() {
    //   this.$emit('load-more');
    // },
    selectItem(index) {
      this.selectedItem = this.data[index];
      this.$emit('select-item', this.selectedItem);
    },
  },
};
</script>

<style scoped>
.external-link {
  color: inherit;
  text-decoration: none;
}
.panel-notification.is-scroll {
  height: calc(100% - 150px) !important;
}
.ct-icon {
  width: 10px;
  height: 10px;
  color: rgb(0, 127, 234);
}
</style>
